"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("./api");
const resolve_1 = require("../util/resolve");
class TorchDataDefinitions {
    constructor(host, authToken) {
        this.host = host;
        this.authToken = authToken;
    }
    async getDatasetLibrary(signal) {
        return api_1.dataset.list(this.host, this.authToken, signal);
    }
    async getDatasetByName(name, signal) {
        return await api_1.dataset.get(this.host, this.authToken, name, signal);
    }
    async getSchemas(signal) {
        return await api_1.schema.list(this.host, this.authToken, signal);
    }
    async getDatasetBySchema(name, signal) {
        let schemaDS = await api_1.schema.get(this.host, this.authToken, name, signal);
        return schemaDS.datasets;
    }
    async resolveField(field, datasetName, signal) {
        let datasetByName = {};
        datasetByName[datasetName] = await this.getDatasetByName(datasetName, signal);
        return TorchDataDefinitions.resolveField(field, datasetName, datasetByName);
    }
    static resolveField(field, datasetName, datasetByName) {
        /**
         * There are 6 use cases:
         * 1. dataset:field_name                    (zip-geo:fips)
         * 2. dataset::field_type
         *     a. dataset exists                    (hospital::key)
         *     b. dataset doesn't exist             (year-month::key)
         * 3. dataset::field_type::override_name    (health-system::id::affiliated_health_system_id)
         * 4. field_name                            (drg_group)
         * 5. ::field_type                          (::id)
         */
        let parts = field.split('::');
        if (parts.length > 1) {
            if (!parts[0]) {
                // Use case 5
                let datasetDef = datasetByName[datasetName];
                return [datasetDef.name, (0, resolve_1.resolveFieldType)(parts[1], datasetDef)];
            }
            else if (parts.length === 3) {
                // Use case 3
                let datasetDef = datasetByName[parts[0]];
                let field = (0, resolve_1.resolveFieldType)(parts[1], datasetDef);
                return [datasetDef.name, field, parts[2]];
            }
            else {
                let datasetDef = datasetByName[parts[0]];
                if (datasetDef) {
                    // Use case 2a
                    return [datasetDef.name, (0, resolve_1.resolveFieldType)(parts[1], datasetDef)];
                }
                else {
                    // Use case 2c
                    return [null, parts[0].replace(/-/g, '_') + '_' + parts[1]];
                }
            }
        }
        else {
            parts = field.split(':');
            if (parts.length > 1) {
                // Use case 1
                return [parts[0], parts[1]];
            }
            else {
                // Use case 4
                let datasetDef = datasetByName[datasetName];
                return [datasetDef.name, field];
            }
        }
    }
    static resolveKey(datasetDef) {
        if (datasetDef.keyField)
            return datasetDef.keyField;
        return datasetDef.name.replace(/-/g, '_') + '_' + datasetDef.tableType + '_key';
    }
    static resolveId(datasetDef) {
        if (datasetDef.idField)
            return datasetDef.idField;
        return 'torch_' + datasetDef.name.replace(/-/g, '_') + '_id';
    }
    static resolveFieldType(fieldType, datasetDef) {
        if (fieldType === 'id')
            return TorchDataDefinitions.resolveId(datasetDef);
        else if (fieldType === 'key')
            return TorchDataDefinitions.resolveKey(datasetDef);
    }
}
exports.default = TorchDataDefinitions;
